import React from "react";
import { resolveLogoUrl } from "@/lib/media";

export default function BrandLogo({ settings, language = "en", footer = false }) {
  const logo = resolveLogoUrl(settings, language);
  return (
    <>
      <img className={footer ? "brand-logo footer-logo" : "brand-logo"} src={logo} alt="Protech Heating & Cooling logo" />
      <span className="brand-wordmark">
        <span className="brand-name">Protech</span>
        <span className="brand-subline">Heating & Cooling</span>
      </span>
    </>
  );
}
